import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface TrialStatus {
  school_id: string;
  school_name: string;
  plan_name: string;
  is_trial: boolean;
  trial_period_days: number;
  trial_active: boolean;
  trial_expired: boolean;
  trial_activated_at: string;
  trial_valid_till: string;
}

export interface ExpireTrialsResponse {
  updated_count: number;
  updated_school_ids: string[];
}

export interface TrialExpiredResponse {
  warning: string;
  status: string;
  reason: string;
  trial_activated_at: string;
  trial_valid_till: string;
}

@Injectable({
  providedIn: 'root'
})
export class TrialSubscriptionService {
  private baseUrl = environment.pythonApiUrl;

  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  // Get school trial status
  getSchoolTrialStatus(schoolId: string): Observable<TrialStatus> {
    return this.http.get<TrialStatus>(`${this.baseUrl}/api/school-trial-status/?school_id=${schoolId}`, {
      headers: this.getHeaders()
    });
  }

  // Expire trials (manual trigger)
  expireTrials(schoolId?: string): Observable<ExpireTrialsResponse> {
    const body = schoolId ? { school_id: schoolId } : {};
    return this.http.post<ExpireTrialsResponse>(`${this.baseUrl}/api/expire-trials/`, body, {
      headers: this.getHeaders()
    });
  }

  // Calculate days remaining
  getDaysRemaining(trialValidTill: string): number {
    const now = new Date();
    const validTill = new Date(trialValidTill);
    const diffTime = validTill.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(0, diffDays);
  }

  // Format date for display
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  }
}
